import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const historyKey: PluginKey = new PluginKey('history');
